import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.scrolling = false

    this.sections = this.linkTargets.map((link) => {
      const id = link.getAttribute("href").slice(1)
      return document.getElementById(id)
    }).filter(Boolean)

    this.observer = new IntersectionObserver(
      (entries) => {
        if (this.scrolling) return

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.#activate(entry.target.id)
          }
        })
      },
      { rootMargin: "-30% 0px -70% 0px" }
    )

    this.sections.forEach((section) => this.observer.observe(section))

    // Activate the section currently in view, or default to the first
    const active = this.sections.findLast((section) => {
      return section.getBoundingClientRect().top <= window.innerHeight * 0.3
    })
    this.#activate((active || this.sections[0])?.id)

    this.linkTargets.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault()
        const id = link.getAttribute("href").slice(1)
        this.scrolling = true
        this.#activate(id)
        document.getElementById(id)?.scrollIntoView()

        // Re-enable observer after scroll settles
        clearTimeout(this.scrollTimer)
        this.scrollTimer = setTimeout(() => { this.scrolling = false }, 100)
      })
    })
  }

  disconnect() {
    this.observer?.disconnect()
    clearTimeout(this.scrollTimer)
  }

  #activate(id) {
    this.linkTargets.forEach((link) => {
      const isActive = link.getAttribute("href") === `#${id}`
      link.classList.toggle("text-ink", isActive)
      link.classList.toggle("font-bold", isActive)
      link.classList.toggle("border-brand", isActive)
      link.classList.toggle("border-transparent", !isActive)
      link.classList.toggle("text-ink-muted", !isActive)

      if (isActive) {
        const nav = this.element
        const linkLeft = link.offsetLeft
        const linkRight = linkLeft + link.offsetWidth
        const navScrollLeft = nav.scrollLeft
        const navWidth = nav.offsetWidth

        if (linkLeft < navScrollLeft) {
          nav.scrollTo({ left: linkLeft, behavior: "smooth" })
        } else if (linkRight > navScrollLeft + navWidth) {
          nav.scrollTo({ left: linkRight - navWidth, behavior: "smooth" })
        }
      }
    })
  }
}
